export const LOAD_CONTACTS_LIST = 'contacts/LOAD_CONTACTS_LIST';
export const ADD_CONTACT = 'contacts/ADD_CONTACT';
export const UPDATE_CONTACT = 'contacts/UPDATE_CONTACT';
export const DELETE_CONTACT = 'contacts/DELETE_CONTACT';
export const UPDATE_MULTIPLE_CONTACTS = 'contacts/UPDATE_MULTIPLE_CONTACTS';
export const GET_BACKUP_CONTACTS = 'contacts/GET_BACKUP_CONTACTS';
